module.exports = __webpack_public_path__ + "img/ibc.50b3b06c.png";